<template>
  <div class="widthContent">
    <div class="middleContent">
        <BreadList :active="$route.params.type" :info="breadList"/>
        <p class="title" v-if="$route.params.type!='8'">{{breadList[$route.params.type-1].title}}</p>
		<p class="title" v-if="$route.params.type=='8'">{{breadList[4].title}}</p>
        <p class="desc" v-if="$route.params.type!='8'">{{breadList[$route.params.type-1].en}}</p>
		<p class="desc" v-if="$route.params.type=='8'">{{breadList[4].en}}</p>
        <div class="contentHtml" v-html="htmlText"></div>
        <List :listInfo="listData" v-if="$route.params.type=='2'" />
		<List :listInfo="listEatData" v-if="$route.params.type=='8'" />
    </div>
    <Swiper :listInfo="swiperData" v-if="$route.params.type=='1'" />
  </div>
</template>

<script>
import BreadList from '../BreadLink'
import Swiper from './swiper'
import List from './departList'
import link from '@/link.js'
import api from '@/api/api'
export default {
  name: 'index',
  components:{
    BreadList,
    Swiper,
    List
  },
  data () {
    return {
      breadList:link[3].list,
      htmlText:"",
      listData:[],//机构养老列表
      swiperData:[],//
	  listEatData:[]
      }
  },
  watch:{
    $route(){
      this.getData();
    }
  },
  methods:{
    getData(){
      api.getCompanyInfo({
        subType:this.$route.params.type,
        type:"3"
      }).then(res=>{
				console.log('ddd',res)
        if(res.data.code===0){
          this.htmlText = res.data.data.news.text;
          this.listData = res.data.data.nursingHomeList;
          this.swiperData = res.data.data.jujia;
		  this.listEatData = res.data.data.canteenList
        }else{
          this.htmlText="暂时没有数据！"
        }

      })
    }
  },
  created(){
    this.getData();
  }
}
</script>
<style lang="scss" scoped>
    .widthContent{
        .title{
            width: 100%;
            line-height: 34px;
            font-size: 28px;
            font-weight: bold;
            margin-top: 30px;
        }
        .desc{
            font-size: 16px;
            line-height: 24px;
            color: #909399;
            margin-top: 12px;
            padding-bottom: 22px;
            text-transform: uppercase;
        }
    }
  @media screen and (max-width: 1200px){
      .widthContent{
        .title{
          font-size: 24px;
        }
        .desc{
          font-size: 14px;
        }
      }
    }
</style>





// WEBPACK FOOTER //
// src/components/department/List.vue